<template>
  <div>
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="details-box">
      <div class="details-bg"></div>
      <div class="details-body">
        <div class="details-left-box">
          <div class="details-h1">
            <p class="details-h1-left"><span>账号交易</span> > 商品详情</p>
            <span class="details-h1-right" @click="toBack">< 上一级</span>
          </div>
          <div class="details-info">
            <div class="details-image-box">
              <div class="trade-swiper-body"> 
                <div class="trade-swiper-btn trade-swiper-button-prev"></div>
                <div class="trade-swiper-container swiper-container" id="trade_banner_swiper">
                    <div class="swiper-wrapper">
                        <div class="trade-swiper-slide swiper-slide" v-for="(item, index) in tradeImage" :key="index">
                            <img :src="baseAddress+item"  @click="showPicture(item)"/>
                        </div>
                    </div>
                </div> 
                <div class="trade-swiper-btn trade-swiper-button-next"></div>
              </div>             
              <p class="details-state">商家状态 : <span>{{loginTime}}</span></p>
            </div>
            <div class="details-data">
              <span class="details-data-title">{{tradeTitle}}</span>
              <p class="details-price">价&emsp;&emsp;格&nbsp;:&nbsp;
                <span style="font-size: 16px;">¥</span>
                <span>{{tradeSole}}</span>
              </p>
              <p class="details-item">
                <span>充值金额&nbsp;:&nbsp;</span>
                {{tradeInvest}}元
              </p>
              <p class="details-item">
                <span>区&emsp;&emsp;服&nbsp;:&nbsp;</span>
                {{tradeGameAreaName}}
              </p>
              <p class="details-summary">
                <span class="details-summary-label">商品描述&nbsp;:&nbsp;</span>
                <span class="details-summary-body">{{tradeSelling}}撒娇的哈时间段哈事件回调金沙大家好撒旦教哈时间动画撒建行到家啊实打实的骄傲圣诞节哈师大假按揭</span>
              </p>
              <p class="details-item details-time">
                <span>剩余时间&nbsp;:&nbsp;</span>
                {{endTimeText}}
              </p>
              <p class="details-item">
                <span>服务保险&nbsp;:&nbsp;</span>
                <i>审核属实</i>
                <i>实名认证</i>
                <i>自行发售</i>
              </p>
              <div class="details-sole-state">
                <span>商品状态&nbsp;:&nbsp;</span>
                <p class="details-sole" v-if="tradeState == 1">在售中</p>
                <p class="details-sole details-sell" v-if="tradeState == 3">已售</p>
              </div>    
            </div>
          </div>
          <div class="details-pay" v-if="!tradeUserState">
            <span class="details-pay-header">
              <i></i>填写购买信息<i></i>
            </span>
            <Form ref="payBean" :model="payBean" :rules="ruleBean" :label-width="115" class="details-form">
              <FormItem label="购买数量 :">
                <Input size="large" style="width: 250px;" disabled value="1"></Input>
              </FormItem>
              <FormItem label="QQ :" prop="pay_qq">
                <Input size="large" style="width: 250px;" v-model="payBean.pay_qq" placeholder="请输入QQ"></Input>
              </FormItem>
              <FormItem label="手机号码 :" prop="pay_phone">
                <Input size="large" style="width: 250px;" v-model="payBean.pay_phone" placeholder="请输入手机号码"></Input>
              </FormItem>
              <div class="details-hint">
                温馨提示: 联系方式请您填写真实有效,以便客服发货时可以及时联系到您。
              </div>
              <FormItem label="应付金额 :" prop="pay_money" v-model="payBean.pay_money">
                <div class="pay-money"><i>¥</i>{{tradeSole}}</div>
              </FormItem>
              <FormItem label="支付方式 :" prop="pay_type">
                <RadioGroup v-model="payBean.pay_type">
                  <Radio label="15" style="margin-right: 25px;">
                    <span style="margin-left: 10px;">支付宝扫码</span>
                  </Radio>
                  <Radio label="26">
                    <span style="margin-left: 10px;">微信支付</span>
                  </Radio>
                  <Radio label="32">
                    <span style="margin-left: 10px;">平台币支付</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="pay_contract">
                <div class="pay-contract">
                  <CheckboxGroup  v-model="payBean.pay_contract">
                    <Checkbox>
                      <span>我已经了解
                        <a class="pay-a" href="/deal" target="_blank" title="101游戏买卖服务协议">《101游戏买卖服务协议》</a>
                        <a class="pay-a" href="" target="_blank" title="授权委托书">《授权委托书》</a>
                      </span>
                    </Checkbox>
                  </CheckboxGroup>
                </div>
              </FormItem>
              <Button size="large" type="primary" @click="handleSubmit('payBean')"
               class="pay-submit">提交订单</Button>
            </Form>
          </div>
        </div>
        <div class="details-right-box">
          <div class="details-header">
            <i class="details-icon"></i>
            <span class="details-title">最新发布</span>
          </div>
          <ul class="details-ul">
            <li class="details-li" v-for="(item,index) in newList" :key="index"
              @click="enterTradeDetails(item.trade_id)">
              <span class="details-li-title">{{item.trade_title}}</span>
              <span class="details-li-money">¥{{item.trade_money}}</span>
            </li>
          </ul>
          <div class="details-header">
            <i class="details-icon"></i>
            <span class="details-title">热门商品</span>
          </div>
          <ul class="details-ul">
            <li class="details-li" v-for="(item,index) in hotList" :key="index"
              @click="enterTradeDetails(item.trade_id)">
              <span class="details-li-title">{{item.trade_title}}</span>
              <span class="details-li-money">¥{{item.trade_money}}</span>
            </li>
          </ul>
          <span class="details-scan">扫码下载客户端</span>
          <div class="details-scan-box">
            <img class="details-image" :src="baseQrAddress+'type=qr_apk&game_tag=apk'">
            <div class="details-qr-mask">
              <div class="detalis-qr-scan"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details-ad-box"></div>
    <div class="modal" v-if="showChatState">
      <div class="modal-content">
        <div class="popup-box" style="border:none;font-size: 20px;text-align: left;font-weight: bold;">
          <i class="icon-recharge icon-chat" style="width: 40px;"></i>
          <span class="popup-title">微信支付</span>
          <span class="popup-close modal-close" @click="closeChatModal" style="font-size: 14px;">取消</span>
        </div>
        <img :src="chatAddress" style="width: 200px;height: 200px;margin: 10px auto;">
        <img src="../../assets/image/common_wechat_hint_normal.png" style="width: 160px;margin: 0 auto;">
      </div>
    </div>
    <div v-show="showPopState" class="pop-mask" @click="closePop"></div>
    <div v-show="showPopState" class="pop-trade-body">
      <div class="top"></div>
      <div class="body">
        <div class="header">
          <span class="title">交易预览图</span>
          <img class="close" src="../../assets/image/window_close_normal.png" alt="关闭" @click="closePop">
        </div>
        <img class="img" :src="tradeImg">
      </div>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
    @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
    @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from '../../components/common/Footer';
  import Header from '../../components/common/Header';
  import SuspendSide from '../../components/SuspendSide';
  import SuspendMember from '../../components/SuspendMember';
  import Swiper from "swiper";
  import "swiper/css/swiper.css";
  export default {
    metaInfo(){
      return {
        title:"交易详情_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    components: {
      Header, Footer, SuspendSide,SuspendMember
    },
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      baseQrAddress(){
        return this.$store.state.constant.baseQrAddress;
      },
    },
    asyncData({store,route}){
      return store.dispatch('initSeo',{store:store})
    },
    data() {
      return {
        tradeTid:0,
        tradeUserState:false, //交易用户状态
        tradeState:0, //交易状态
        tradeSelling:0,
        tradeGameAreaName:"",
        tradeImage:[],
        tradeInvest:0,
        tradeSole:0,
        tradeTitle:"",
        userLoginTime:0,
        tradeUpdateTime:0,
        tradeEndTime:0,

        newList:[],
        hotList:[],
        ruleBean:{
          pay_qq:[
            { required: true, message: '请输入qq', trigger: 'blur'}
          ],
          pay_phone:[
            { required: true, message: '请输入手机号', trigger: 'blur'}
          ],
          pay_money:[
            { required: true, message: '请输入应付金额'}
          ],
          pay_type:[
            { required: true, message: '请选择支付类型', trigger: 'change'},
          ],
          pay_contract:[
            { required: true, type: 'array', min: 1, message: '请先阅读协议', trigger: 'change' },
          ]
        },
        payBean:{
          pay_qq:'', //qq号码
          pay_phone:'', //手机号码
          pay_discount:'', //优惠码
          pay_money:'', //应付金额
          pay_type:0, //支付类型
          pay_contract:[], //交易协议
          pay_tid:'',
        },
        loginTime:'',
        cacheTime:'',
        cacheCoin:0, //缓存平台币
        showChatState:false,
        wechatPayTimer:"",
        chatAddress:"",
        order_oid:"",
        pay_type:0,
        secondTime:0,
        endTimeText:"",
        suspendState:false,
        suspendType:0,
        loginState:false,
        tradeSwiperOption:{
          slidesPerGroup: 1,
          loop: true, 
          speed: 600,
          parallax: true,
          navigation: {
              prevEl: ".trade-swiper-button-prev",
              nextEl: ".trade-swiper-button-next",
          },
        },
        tradeSwiper:"",
        showPopState:false,
        tradeImg:"",
      };
    },
    mounted(){
      if (window.sessionStorage.getItem("token") !== null) {
        this.loginState = true;
      }
      this.pay_type = this.$route.query.type;
      this.order_oid = this.$route.query.order_id;
      if(this.pay_type != undefined && this.order_oid != undefined){
        if(this.pay_type == 1){
          this.queryPayResult(this.order_oid,this.$route.query.pay_type);
        }else if(this.pay_type == 2){
          this.queryChatPayResult();
        }
      }  
      this.tradeTid = this.$route.query.tid;
      this.payBean.pay_tid = this.tradeTid;
      this.queryTrade();
    },
    methods:{
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      initTradeSwiper(){
        this.tradeSwiper = null;
        this.tradeSwiper = new Swiper("#trade_banner_swiper",this.tradeSwiperOption);
      },
      closePop(){
        this.showPopState = false;
      },
      showPicture(value){
        this.showPopState = true;
        this.tradeImg = this.baseAddress + value;
      },
      queryTrade(){
        this.$http.post('get_trade?tid='+this.tradeTid,{
        }).then(res=>{
          if (res.data.code == 2000) {
            var trade = res.data.data.trade;
            this.tradeUserState = trade.trade_user_state;
            this.tradeState = trade.trade_state;
            this.tradeSelling = trade.trade_selling;
            this.tradeGameAreaName = trade.trade_game_area_name;
            this.tradeInvest = trade.trade_invest;
            this.tradeTitle = trade.trade_title;
            this.tradeSole = trade.trade_sole;
            this.tradeUpdateTime = trade.trade_update_time;
            this.tradeEndTime = trade.trade_end_time;
            this.userLoginTime = trade.user_login_time;
            if(trade.trade_image.length > 0){
              this.tradeImage = trade.trade_image;
              this.initTradeSwiper();
            }
            this.hotList = res.data.data.hotList;
            this.newList = res.data.data.newList;
            if(this.userLoginTime > 0){//处理卖家更新与登陆
              this.loginTime = "卖家"+this.handleTime(this.userLoginTime)+"来过 "+
              this.handleTime(this.tradeUpdateTime)+"更新";
            }
            if(this.tradeEndTime >= 0){
              let nowTime = new Date().getTime();
              if(this.tradeEndTime > nowTime){
                this.secondTime = (this.tradeEndTime - nowTime) / 1000;
              }else{
                this.secondTime = 864000
              }
              clearInterval(this.cacheTime);
              this.endTime();
            }
          }else{
            this.hotList = [];
            this.newList = [];
          }
        })
      },
      enterTradeDetails(value){
        window.open(this.$router.resolve({name:'tradeDetails',query:{tid:value}}).href,"_blank");
      },
      countDown(){
        let d = parseInt(this.secondTime / (24 * 60 * 60));
        d = d < 10 ? "0"+ d : d;
        let h = parseInt(this.secondTime / (60 * 60) % 24);
        h = h < 10 ? "0" + h : h;
        let m = parseInt(this.secondTime / 60 % 60);
        m = m < 10 ? "0" + m : m;
        let s = parseInt(this.secondTime % 60);
        s = s < 10 ? "0" + s : s;
        this.endTimeText = d + '天' + h + '时' + m + '分' + s + '秒';
      },
      endTime(){
        this.cacheTime = setInterval(() => {
          this.secondTime -= 1;
          this.countDown();
        }, 1000);
      },
      handleTime(value){
        let time = new Date().getTime();
        let now = (time - value)/1000;
        if(now < 60){
          return "刚刚";
        }else if(60 < now && now < 3600){
          return Math.floor(now/(3600))+"分钟前";
        }else if(3600 < now && now < 86400){
          return Math.floor(now/(3600))+"小时前";
        }else if(86400 < now && now < 2592000){
          return Math.floor(now/(86400))+"天前";
        }else if(2592000 < now && now < 31104000){
          return Math.floor(now/(2592000))+"月前";
        }else{
          return Math.floor(now/(31104000))+"年前";
        }
      },
      handleSubmit(name){ //处理支付
        this.payBean.pay_money = this.tradeSole;
        this.$refs[name].validate((valid) =>{
          if(!valid){
             alert("请先填写完购买信息!");
            return;
          }
          this.$http.post("/request_trade_pay",{
            data:{
              pay_type:this.payBean.pay_type,
              pay_qq:this.payBean.pay_qq,
              pay_money:this.payBean.pay_money,
              pay_phone:this.payBean.pay_phone,
              pay_discount:this.payBean.pay_discount,
              pay_tid:this.payBean.pay_tid
            }
          }).then(res=>{
            if (res.data.code ===1066) {
              if(this.payBean.pay_type == 15){
                const form = res.data.data.order_pay;
                const div = document.createElement('div');
                div.id = 'alipay';
                div.innerHTML = form;
                document.body.appendChild(div);
                document.querySelector('#alipay').children[0].submit();
              }else if(this.payBean.pay_type == 26){
                this.showChatState = true;
                this.chatAddress = res.data.data.order_pay;
                this.order_oid = res.data.data.order_oid;
                this.pay_type = 26;
                this.queryChatPayResult();
                this.chatPayTimer = setInterval(this.queryChatPayResult,5000);
              }else if(this.payBean.pay_type == 32){
                this.cacheCoin = this.cacheCoin - this.payBean.pay_money;
                window.sessionStorage.setItem("userMoney",this.cacheCoin);
                //返回交易
                alert(res.data.msg);
                this.$router.push({name:'trade'});
              }
            }else{
              if(this.payBean.pay_type == 32){
                alert("持有的平台币数额不够!");
              }else{
                alert(res.data.msg);
              }
            }
          });
        });
      },
      queryPayResult(value,type){ //查询支付结果
        this.$http.post(`/set_trade_pay_result?order_oid=`+value+"&pay_type="+type,{})
        .then(res=>{
          alert(res.msg);
        })
      },
      queryChatPayResult(){
        this.$http.post(`/set_trade_pay_result?order_oid=`+this.order_oid,{})
        .then(res=>{
          if(res.data.code == 1050 || res.data.code == 1085){
            if(res.data.code == 1050){
              if(this.payTo == 2){
                //充值到平台币
                this.cacheCoin = this.cacheCoin + this.payDataBean.amount;
                window.sessionStorage.setItem("userMoney",this.cacheCoin);
              }
            }
            alert(res.msg);
            this.showChatState = false;
            clearInterval(this.wechatPayTimer);
          }
        })
      },
      closeChatModal(){
        this.showChatState = false;
        clearInterval(this.chatPayTimer)
      },
      toBack(){
        this.$router.push({name:'trade'});
      }
    },
    watch:{
      '$route' (to, from){
        this.initData();
      },
      loginState(value){
        if(value){
          this.queryTrade();
        }
      }
    } 
  };
</script>
<style src="@/assets/css/trade/trade_details.css" scoped></style>
